<template>
  <div class="m-card-primary m-the-modal-content">
      <header class="m-the-modal-header">
        <h5 class="m-the-modal-header-title-error">
          {{ $t('mLicenseModalUpgrade.title') }}
        </h5>
        <AtomButtonTheModalCloseIcon/>
      </header>
      <section class="m-the-modal-section">
        <p class="font-weight-bold margin-bottom-xlarge text-color-danger">
          {{ $t(`mLicenseModalUpgrade.messages['${this.$modal.element}']`) }},
          {{ $t('mLicenseModalUpgrade.messages.upgrade') }}
          <router-link
            :to="`/${this.$t('rPaths.billing')}/${this.$t('mEditionMenu.billing.myPayments.subject')}/${this.$t('mEditionMenu.billing.myPayments.children.changePlan.subedition')}`"
            class="text-link-hover-academy"
            @click.native="$modal.closeModal"
          >
            <i class="fas fa-link font-size-small"></i>
            {{ $t('mLicenseModalUpgrade.messages.link') }}.
          </router-link>
        </p>
      </section>
  </div>
</template>

<script>
export default {
  name: 'MoleculeLicenseModalUpgrade',

  data () {
    return {
      buttonPrimary: {
        action: this.$t('mLicenseModalUpgrade.buttonPrimary'),
        class: 'a-button-academy-primary',
        sending: false,
        type: 'submit'
      }
    }
  }
}
</script>
